<template>
    <nav class="bg-white md:border-b">
        <mobile-nav>
            <template #logo>
                <slot name="logo" />
            </template>
            <slot />
        </mobile-nav>

        <desktop-nav>
            <template #logo>
                <slot name="logo" />
            </template>
            <slot />
        </desktop-nav>
    </nav>
</template>
